/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramConnectionsUserControllerFindAllQueryResponse,
  TelegramConnectionsUserControllerFindAllQueryParams,
  TelegramConnectionsUserControllerFindAll401,
} from '../types/TelegramConnectionsUserControllerFindAll.ts';

function getTelegramConnectionsUserFindAllUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/connections` as const };
  return res;
}

/**
 * {@link /api/user/telegram/connections}
 */
export async function telegramConnectionsUserFindAll(
  params: TelegramConnectionsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramConnectionsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramConnectionsUserControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getTelegramConnectionsUserFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
